<div class="select">
    <div class="inputHeader-induxtry">
        <span class="firstLabel" [ngStyle]="selectInput?.styleLabel">
            {{ selectInput.label }}
            <span class="optionalLabel" *ngIf="selectInput?.subLabel"
                [ngStyle]="selectInput?.styleSubLabel">{{selectInput?.subLabel}}</span>
            <div class="icon_tooltip" [matTooltip]="selectInput?.iconTooltip?.text"
                [matTooltipPosition]="selectInput?.iconTooltip?.position ? selectInput?.iconTooltip?.position : 'above'"
                matTooltipClass="induxtry-tooltip">
                <mat-icon [svgIcon]="selectInput?.iconTooltip?.icon"></mat-icon>
            </div>
        </span>
    </div>
    <mat-form-field [floatLabel]="'always'" appearance="outline" class="custom-outline-select-input">
        <mat-select class="testeSelect" [placeholder]="selectInput.placeholder" msInfiniteScroll
            (infiniteScroll)="infiniteScroll()" [disabled]="selectInput.disabled" [(ngModel)]="selectInput.value"
            (selectionChange)="setNewValue()">

            <mat-option *ngFor="let option of selectInput.options; index as i" [value]="option?.value">
                <span>
                    {{option?.viewValue}}
                </span>
            </mat-option>
            <mat-option *ngIf="loading" disabled class="loading-mat-option">
                <loading class="loading-option" [size]="'23px'"></loading>
            </mat-option>
            @if(clearButton) {
            <div class="clear-button">
                <div style="padding: 8px 8px 8px 8px;">
                    <button-induxtry [buttonProperties]="buttonClear" (action)="handleClear($event)">
                    </button-induxtry>
                </div>
            </div>
            }
        </mat-select>
    </mat-form-field>
</div>